export default "__VITE_ASSET__Dr3N0t5L__"